import { Resolver } from '@wellyes/react-router-extended';
import { HttpService } from '@core/services';
import { PermittingHttpService } from '@core/services/http';
import { getParamFromURL } from '@core/utils/methods';
import { JurisdictionActions } from '@store/actions';
import store from '@store/index';

export class JurisdictionDetailsResolver implements Resolver {
  async resolve(): Promise<void> {
    store.dispatch(JurisdictionActions.resetTabsData.done());

    const [, jurisdictionName] = getParamFromURL(
      'Jurisdiction Name',
      /^\/permitting\/jurisdiction\/(.+)\/details[/\w+]*$/,
    );

    await HttpService.getHttpRequests(
      PermittingHttpService,
    ).getJurisdictionZoning(jurisdictionName);
  }
}
